// Texty ukazatele hmotnostních pásem (weightScale.js); ostatní znění škály
// nese locale shippingModel.js.
import { NBSP } from '../../modules/money.js';

export default {
  free: 'Zdarma',
  /** akce na dopravu (#322): výdejní místo „od 19 Kč" */
  promoFrom: (price) => 'od ' + price,
  /** „Akce: PPL na výdejní místo do 10 kg za 19 Kč, platí do 25. 10." */
  promoNote: (carrier, price, maxKg, until) =>
    'Akce: ' + carrier + ' na výdejní místo do ' + maxKg + NBSP + 'kg za ' + price + ', platí do ' + until.replace(/\.$/, '') + '.',
};
